export const AppContentStyle = `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background-color: '#607d84'
`;
